import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Box from "../../../../../../ui/Box";
import SquareButton from "../../../../../../ui/SquareButton";

const useStyles = makeStyles(() => ({
  topBar: {
    display: "flex",
    justifyContent: "space-between"
  },
  topBarLeft: {
    display: "flex",
    "& > button": {
      marginRight: 12
    }
  },
  topBarRight: {
    display: "flex",
    "& > div": {
      marginLeft: 12
    }
  }
}));

const TopBar = ({
  reload,
  returnBack
}) => {
  const classes = useStyles();

  return (
    <Box>
      <div className={classes.topBar}>
        <div className={classes.topBarLeft}>
          <SquareButton onClick={returnBack}>
            <ChevronLeftIcon fontSize="small" />
          </SquareButton>
          <SquareButton onClick={reload}>
            <CachedIcon fontSize="small" />
          </SquareButton>
        </div>
      </div>
    </Box>
  );
};

export default withRouter(TopBar);
